import React from 'react'
import { useFormContext, useWatch } from 'react-hook-form'
import { Message } from 'semantic-ui-react'
import styled from 'styled-components'
import { formatNumber } from '~/utils/helpers'

const StyledMessage = styled(Message)`
background-color: #fcfff5 !important;
color: #2c662d !important;
width: 450px;
margin: 0px !important;
`
interface Props {
  keySilage?: 'grassSilage' | 'maizeSilage'
}

const GroupTwo:React.FC<Props> = ({ keySilage }) =>{
  const { control } = useFormContext()
  const mainKey = keySilage || 'grassSilage'
  const watchField = useWatch({ control, name: `${mainKey}.mineralFertilizers` }) || []

  const totalSum = watchField.reduce((total, item) => {
    const numericValue = parseFloat(item?.value?.replace(',', '.'));
    return total + (isNaN(numericValue) ? 0 : numericValue);
  }, 0)

  const sumGroupTwo = watchField.reduce((total, item) => {
    const numericValue = item?.calculationGroup2 === 1 ? parseFloat(item?.value?.replace(',', '.')) : 0;
    return total + (isNaN(numericValue) ? 0 : numericValue);
  }, 0)

  const percentage = totalSum ? Math.floor(sumGroupTwo / totalSum * 100) : 0

  return <StyledMessage>
    <Message.Header>{'Ihr Anteil AHL am Mineraldünger-Stickstoff beträgt:'}</Message.Header>
    <Message.Content>{`${formatNumber(percentage, 2)} %`}</Message.Content>
  </StyledMessage>
}
export default GroupTwo